var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-tabs-slider relative overflow-hidden w-full"},[_c('VueSlickCarousel',_vm._b({key:_vm.reset,ref:"slider",on:{"reInit":_vm.onInitCarousel}},'VueSlickCarousel',_vm.settings,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }